import Vue from 'vue'
import Vuex from 'vuex'
import faq from "../api/faq"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        authToken: undefined,
        locale: "de",
        userLoaded: false,
        hasError: false,
        user: {
            id: undefined,
            salutation: undefined,
            email: undefined,
            firstName: undefined,
            lastName: undefined,
        },
        httpClient: undefined,
        faqCategories: [],
        loading: false
    },
    mutations: {
        locale(state, value) {
            state.locale = value;
        },
        userLoaded(state, value) {
            state.userLoaded = value;
        },
        hasError(state, value) {
            state.hasError = value;
        },
        user(state, value) {
            state.user = value;
        },
        authToken(state, value) {
            state.authToken = value;
        },
        faqCategories(state, value) {
            state.faqCategories = value;
        }
    },
    getters: {
        locale(state) {
            return state.locale;
        },
        userLoaded(state) {
            return state.userLoaded;
        },
        hasError(state) {
            return state.hasError;
        },
        user(state) {
            return state.user;
        },
        authToken(state) {
            return state.authToken;
        },
        fullName(state) {
            if(state.user === undefined || state.user === null) return;
            if(state.user.firstName === undefined || state.user.firstName === null) return;
            if(state.user.lastName === undefined || state.user.lastName === null) return state.user.firstName;
            return state.user.firstName + " " + state.user.lastName;
        }
    },
    actions: {
        user(context, user) {
            context.commit("user", user);
        },
        async loadFAQs({state, commit}) {
            state.loading = true;
            const faqCategories = (await faq.loadFAQCategories()).faqCategories;
            commit("faqCategories", faqCategories.map((category) => {
                category.iconUrl = process.env.VUE_APP_BASE_URL + "/api/v1/faq/icon/download/" + category.iconId;
                return category;
            }).sort((a, b) => {
                if (a.sortIndex > b.sortIndex) return 1;
                else return -1;
            }));

            state.loading = false;
        }
    }
})
